// src/components/BottomNavBar2025HLN.js

import React from "react";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import Tooltip from "@mui/material/Tooltip";
import GroupIcon from "@mui/icons-material/Group";
import ChatIcon from "@mui/icons-material/Chat";
import MovieIcon from "@mui/icons-material/Movie";
import StarIcon from "@mui/icons-material/Star";

const BottomNavBar2025HLN = ({
  value,
  onChange,
  handleMissionClick,
  user,
}) => {
  if (!user) return null;

  return (
    <BottomNavigation
      showLabels
      value={value}
      onChange={onChange}
      sx={{
        width: "100%",
        boxSizing: "border-box",
        bgcolor: "#ffffff",
        borderTop: "1px solid #e0e0e0",
        height: 56,
        "& .MuiBottomNavigationAction-root": {
          minWidth: 0,
          flex: 1,
          maxWidth: "none",
          px: 0.5, // 余白を少しだけに
        },
        "& .MuiSvgIcon-root": {
          fontSize: 26,
        },
        // ★ ラベルを1行固定にする
        "& .MuiBottomNavigationAction-label": {
          whiteSpace: "nowrap",
          fontSize: 11,
        },
        "& .Mui-selected .MuiBottomNavigationAction-label": {
          fontSize: "12px",        // 選択時も拡大しない
          lineHeight: "12px",
        },
      }}
    >
      <Tooltip title="仲間" arrow>
        <BottomNavigationAction value={0} label="仲間" icon={<GroupIcon />} />
      </Tooltip>

      <Tooltip title="チャット" arrow>
        <BottomNavigationAction value={1} label="チャット" icon={<ChatIcon />} />
      </Tooltip>

      <Tooltip title="八重の誓" arrow>
        <BottomNavigationAction value={2} label="八重の誓" icon={<ChatIcon />} />
      </Tooltip>

      <Tooltip title="12/7" arrow>
        <BottomNavigationAction value={3} label="12/7" icon={<MovieIcon />} />
      </Tooltip>

      <Tooltip title="グループ活動ガイドライン" arrow>
        <BottomNavigationAction
          value={4}
          icon={<StarIcon />}
          onClick={handleMissionClick}
        />
      </Tooltip>
    </BottomNavigation>
  );
};

export default BottomNavBar2025HLN;
